export const FETCH_INFORMATIONS_REQUEST             = 'FETCH_INFORMATIONS_REQUEST';
export const FETCH_INFORMATIONS_SUCCESS             = 'FETCH_INFORMATIONS_SUCCESS';
export const FETCH_INFORMATIONS_FAILURE             = 'FETCH_INFORMATIONS_FAILURE';
export const SET_INFORMATIONS             = 'SET_INFORMATIONS';